import { UserOutlined } from '@ant-design/icons';
import React from 'react';

export default [
{
    name: '登录',
    path: '/login',
    layout: false,
    component: './login',
    icon: <UserOutlined />,
  },
{
    name: '注册',
    path: '/register',
    layout: false,
    component: './register',
    hideInMenu: true,
  }
];
